import React from 'react';

const Empty = (extraStyles?: React.CSSProperties) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={extraStyles}></svg>
    );
};

export default Empty;

